export const BordersAdditive = `
<div className="bd-example bd-example-border-utils">
  <span className="border"></span>
  <span className="border-top"></span>
  <span className="border-right"></span>
  <span className="border-bottom"></span>
  <span className="border-left"></span>
</div>
    `

export const BordersSubtractive = `
<div className="bd-example bd-example-border-utils border-sample subtractive-sample">
  <div class="border-0"></div>
  <div class="border-top-0"></div>
  <div class="border-right-0"></div>
  <div class="border-bottom-0"></div>
  <div class="border-left-0"></div>
</div>
    `

export const BordersColor = `
<div className="bd-example guide-sample border-sample">
  <div class="border border-primary"></div>
  <div class="border border-secondary"></div>
  <div class="border border-tertiary"></div>
  <div class="border border-dark"></div>
  <div class="border border-success"></div>
  <div class="border border-warning"></div>
  <div class="border border-danger"></div>
</div>
    `

export const BordersRadius = `
<div className="bd-example guide-sample border-sample border-radius-sample">
  <div class="rounded"></div>
  <div class="rounded-top"></div>
  <div class="rounded-right"></div>
  <div class="rounded-bottom"></div>
  <div class="rounded-left"></div>
  <div class="rounded-circle"></div>
  <div class="rounded-pill"></div>
  <div class="rounded-0"></div>
</div>
    `
